import Autocomplete from './Autocomplete.component';

export { createFilterOptions } from '@mui/material';

export default Autocomplete;
